import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_core/_services/auth.service';
import { NotificationService } from '../../_core/_services/notification.service';

@Component({
  selector: 'app-two-factor-reminder',
  standalone: false,
  templateUrl: './two-factor-reminder.html',
  styleUrl: './two-factor-reminder.css',
})
export class TwoFactorReminder {
  loading = false;
  error = '';

  private returnUrl: string;

  constructor(
    private notifyService: NotificationService,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    const raw = this.route.snapshot.queryParamMap.get('returnUrl');
    this.returnUrl = raw && raw.startsWith('/') ? raw : '/dashboard';

    // Optional safety: if user doesn't qualify, just proceed
    const u = (this.auth as any).currentUserSubject?.value;
    if (!u || u?.otp?.otpEnabled || !u?.otp?.otpNextReminder || new Date(u.otp.otpNextReminder).getTime() > Date.now()) {
      this.router.navigateByUrl(this.returnUrl, { replaceUrl: true });
    }
  }

  setup2fa() {
    this.router.navigateByUrl('/account/2fa');
  }

  noThanks() {
    this.loading = true;
    this.error = '';

    this.auth.updateOtpReminder(null).subscribe({
      next: () => this.router.navigateByUrl(this.returnUrl, { replaceUrl: true }),
      error: () => {
        this.loading = false;
        this.error = 'Could not update your preference. Please try again.';
        this.notifyService.showError(this.error!, 'Error');
      },
      complete: () => (this.loading = false),
    });
  }

  postpone30() {
    this.loading = true;
    this.error = '';

    const d = new Date();
    d.setDate(d.getDate() + 30);

    this.auth.updateOtpReminder(d.toISOString()).subscribe({
      next: () => this.router.navigateByUrl(this.returnUrl, { replaceUrl: true }),
      error: () => {
        this.loading = false;
        this.error = 'Could not update your reminder. Please try again.';
        this.notifyService.showError(this.error!, 'Error');
      },
      complete: () => (this.loading = false),
    });
  }

}
